import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { SidebarLogo } from './SidebarLogo';
import { ThemeToggle } from './ThemeToggle';

const NAV_TITLE_PT: Record<string, string> = {
  'Create...': 'Modelos',
};

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem
          icon={() => item.icon}
          to={item.href}
          text={NAV_TITLE_PT[item.title] ?? item.title}
        />
      ));

      nav.take('page:search');
      nav.take('page:catalog');
      nav.take('page:catalog-graph');
      nav.take('page:kubernetes');
      nav.take('page:notifications');
      nav.take('page:catalog-import');
      nav.take('page:app-visualizer');
      nav.take('page:techdocs');
      nav.take('page:api-docs');
      nav.take('page:user-settings');

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarDivider />
          <SidebarGroup label="Modelos" icon={<AddCircleOutlineIcon />}>
            <SidebarItem
              icon={AddCircleOutlineIcon}
              to="/create/templates"
              text="Modelos"
            />
          </SidebarGroup>
          <SidebarSpace />
          <ThemeToggle />
        </Sidebar>
      );
    },
  },
});
